import {
  PaginationData,
  SeedTicket,
} from 'constants/interface';
import { SeedTicketStatusEnum } from 'constants/order';
import {
  buildPaginationParams,
  getPaginationHeaders,
  PaginatedResponse,
  requestClient,
} from 'infra/request';

export interface GetSeedTicketList extends PaginationData {
  status?: SeedTicketStatusEnum
}

interface SeedTicketConfirmationData {
  purchaseDate: string
  provider: string
  purchaseQuantity: number
  estimatedReceivingDate: string
}

export interface ConfirmSeedTicketData {
  id: string
  confirmationData: SeedTicketConfirmationData
}

export interface SeedTicketApi {
  getSeedTicket(seedTicketId: string): Promise<SeedTicket>
  getSeedTicketList(filter: GetSeedTicketList): Promise<PaginatedResponse<SeedTicket>>
  confirmSeedTicket(data: ConfirmSeedTicketData): Promise<SeedTicket>
}

const seedTicketApiBuilder = (): SeedTicketApi => {
  const getSeedTicket = async (
    seedTicketId: string,
  ): Promise<SeedTicket> => {
    const result = await requestClient.get(`/seed-tickets/${seedTicketId}`);
    const seedTicket: SeedTicket = result.data as SeedTicket;
    return seedTicket;
  };

  const getSeedTicketList = async (
    filterData: GetSeedTicketList,
  ): Promise<PaginatedResponse<SeedTicket>> => {
    const params = buildPaginationParams(filterData);
    const result = await requestClient.get('/seed-tickets', params);
    const pagination = getPaginationHeaders(result);
    const seedTicketList: SeedTicket[] = result.data as SeedTicket[];
    return {
      pagination,
      data: seedTicketList,
    };
  };

  const confirmSeedTicket = async (
    data: ConfirmSeedTicketData,
  ): Promise<SeedTicket> => {
    const { id: seedTicketId, confirmationData } = data;
    const params: Record<string, unknown> = {
      ...confirmationData,
    };
    const result = await requestClient.post(`/seed-tickets/${seedTicketId}/confirmation`, params);
    const updatedSeedTicket: SeedTicket = result.data as SeedTicket;
    return updatedSeedTicket;
  };

  return {
    getSeedTicket,
    getSeedTicketList,
    confirmSeedTicket,
  };
};

export const seedTicketApi = seedTicketApiBuilder();
